<section class="ms-page" [class.has-dock]="showWizard()">
  <div class="ms-container">
    @if (isLoadingBusiness()) {
      <!-- Skeleton matching the landing layout -->
      <div class="ms-landing animate-pulse" aria-busy="true" aria-label="Cargando información del negocio">
        <div class="ms-identity">
          <div class="ms-skel size-16"></div>
          <div class="space-y-3">
            <div class="ms-skel h-12 w-4/5"></div>
            <div class="ms-skel h-4 w-1/2"></div>
          </div>
          <div class="ms-skel h-14 w-full"></div>
          <div class="grid grid-cols-3 gap-2">
            <div class="ms-skel h-12"></div>
            <div class="ms-skel h-12"></div>
            <div class="ms-skel h-12"></div>
          </div>
        </div>
        <div class="space-y-5">
          <div class="ms-skel h-8 w-40"></div>
          @for (item of [1, 2, 3, 4]; track item) {
            <div class="ms-skel h-16 w-full"></div>
          }
        </div>
      </div>
    } @else if (business()) {
      @if (!showWizard()) {
        <!-- Landing -->
        <div class="ms-landing">
          <div class="ms-identity">
            <app-business-profile-header
              [business]="business()!"
              [isOpen]="isBusinessOpen()"
              [todayHours]="getTodayHoursSummary()">
            </app-business-profile-header>

            <app-microsite-actions-bar
              [business]="business()!"
              [onBookClick]="startBooking.bind(this, null)">
            </app-microsite-actions-bar>
          </div>

          <section aria-labelledby="ms-services-title">
            <div class="ms-menu-head">
              <h2 id="ms-services-title" class="ms-menu-title">Servicios</h2>
              @if (!isLoadingServices() && getWizardServices().length > 0) {
                <span class="ms-menu-count">
                  {{ getWizardServices().length }} {{ getWizardServices().length === 1 ? 'servicio' : 'servicios' }}
                </span>
              }
            </div>

            @if (isLoadingServices()) {
              <div class="animate-pulse space-y-4 pt-5" aria-label="Cargando servicios">
                @for (item of [1, 2, 3]; track item) {
                  <div class="ms-skel h-16 w-full"></div>
                }
              </div>
            } @else if (getWizardServices().length === 0) {
              <p class="ms-empty">
                Este negocio aún no publicó sus servicios. Toca “Agendar cita” para ver qué puedes reservar.
              </p>
            } @else {
              <ul class="ms-menu">
                @for (service of getWizardServices(); track service.serviceId) {
                  <li>
                    <app-service-card
                      [service]="service"
                      actionLabel="Reservar"
                      [onClick]="startBooking.bind(this, service.serviceId)">
                    </app-service-card>
                  </li>
                }
              </ul>
            }
          </section>
        </div>
      } @else {
        <!-- Booking wizard -->
        <div class="ms-wizard-bar">
          <button
            type="button"
            (click)="showWizard.set(false)"
            class="ms-back"
            aria-label="Volver al perfil del negocio">
            <svg class="size-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            @if (business()!.logoUrl) {
              <img [src]="business()!.logoUrl" alt="" class="ms-back-logo" />
            } @else {
              <span class="ms-back-initials" aria-hidden="true">{{ getBusinessInitials() }}</span>
            }
            <span class="truncate">{{ business()!.name }}</span>
          </button>
        </div>

        <app-booking-wizard
          [services]="getWizardServices()"
          [professionals]="getWizardProfessionals()"
          [timeSlots]="getWizardTimeSlots()"
          [businessSchedule]="businessSchedule()"
          [dayAvailabilities]="dayAvailabilities()"
          [isLoadingMonthAvailability]="isLoadingMonthAvailability()"
          [primaryColor]="getPrimaryColor()"
          [businessName]="business()!.name"
          [initialServiceId]="initialServiceId()"
          [isLoadingServices]="isLoadingServices()"
          [isLoadingProfessionals]="isLoadingProfessionals()"
          [isLoadingTimeSlots]="isLoadingTimeSlots()"
          [isSubmitting]="isSubmitting()"
          (serviceSelected)="onServiceSelected($event)"
          (professionalSelected)="onProfessionalSelected($event)"
          (dateSelected)="onDateChange($event)"
          (monthChanged)="onCalendarMonthChanged($event)"
          (bookingComplete)="onBookingComplete($event)"
          (cancelWizard)="showWizard.set(false)">
        </app-booking-wizard>
      }
    } @else if (businessNotFound()) {
      <div class="ms-notfound">
        <div>
          <h1>No encontramos este negocio</h1>
          <p>Revisa que el enlace esté completo. Si te lo enviaron por WhatsApp, pide que te lo compartan de nuevo.</p>
        </div>
      </div>
    }
  </div>

  <footer class="ms-footer">
    <a href="https://citalinkpro.com" target="_blank" rel="noopener noreferrer" class="ms-footer-link">
      Reservas con <strong>CitaLink Pro</strong>
    </a>
  </footer>
</section>
